import React from "react";
import SideBar from "../../components/Sidebar";

const RechargeAndBillPayment = () => {
  const services = [
    {
      name: "Mobile Recharge",
      href: "/mobile-recharge",
      icon: "/assets/images/mobile-icon.png",
    },
    {
      name: "DTH Recharge",
      href: "/dth-recharge",
      icon: "/assets/images/dish-tv-icon.png",
    },
    {
      name: "FasTag Recharge",
      href: "/bill-payment/Fastag",
      icon: "/assets/images/fastag-logo.png",
    },
    {
      name: "Google Play Redeem Code",
      href: "/google-play-redeem-code",
      icon: "/assets/images/google-play-logo.png",
    },
    {
      name: "Mobile Postpaid",
      href: "/bill-payment/Postpaid",
      icon: "/assets/images/postpaid-icon.png",
    },
    // {
    //   name: "Credit Card Bill",
    //   href: "/bill-payment/Credit Card",
    //   icon: "/assets/images/credit-card-icon.png",
    // },
    {
      name: "Loan Repayment",
      href: "/bill-payment/Loan Repayment",
      icon: "/assets/images/loan-payment-icon.png",
    },
    {
      name: "Electricity",
      href: "/bill-payment/Electricity",
      icon: "/assets/images/electricity-bill-icon.png",
    },
    {
      name: "Landline",
      href: "/bill-payment/Landline",
      icon: "/assets/images/landline-icon.png",
    },
    {
      name: "Broadband",
      href: "/bill-payment/Broadband",
      icon: "/assets/images/broadband-icon.png",
    },
    {
      name: "Insurance",
      href: "/bill-payment/Insurance",
      icon: "/assets/images/insurance-icon.png",
    },
    {
      name: "Cable TV",
      href: "/bill-payment/Cable%20TV",
      icon: "/assets/images/cable-tv-icon.png",
    },
    {
      name: "Book Cylinder",
      href: "/bill-payment/LPG%20Booking",
      icon: "/assets/images/gas-cylinder-icon.png",
    },
    {
      name: "Piped Gas",
      href: "/bill-payment/Gas",
      icon: "/assets/images/gas-pipeline-icon.png",
    },
    {
      name: "Water",
      href: "/bill-payment/Water",
      icon: "/assets/images/water-bill-icon.png",
    },
  ];

  return (
    <div>
      <div className="container-fluid mt-3">
        <div className="row">
          {/* Sidebar */}
          <SideBar />

          {/* Main Content */}
          <div className="col-md-9 mb-3">
            <div className="card mb-4 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">Recharge & Bill Payment</h5>
                <div className="row text-center">
                  <div className="container my-4">
                    <div className="row row-cols-2 row-cols-sm-3 row-cols-md-5 g-3">
                      {services.map((service, index) => (
                        <a
                          href={service.href}
                          key={index}
                          className="text-decoration-none"
                        >
                          <div className="col">
                            <div className="p-3 text-center h-100 shadow-sm hover-effect">
                              {/* Circular Icon Box */}
                              <div
                                className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  backgroundColor: "#f1f1f1",
                                }}
                              >
                                <img
                                  src={service.icon}
                                  alt={service.name}
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                              {/* Service Name */}
                              <div
                                className="fw-medium small"
                                style={{ fontSize: "14px", fontWeight: "450" }}
                              >
                                {service.name}
                              </div>
                            </div>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RechargeAndBillPayment;
